import React, { useState } from "react";
import { Col, Row, Table, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import "../../../assets/style/table/deals.scss";
import {
  dealSelector,
  templatesMessageSelector,
} from "../../../services/selector/index.";
import {
  IconDetail,
  IconEdit,
  IconLock,
  IconNext,
  IconPlus,
  IconPre,
  IconSpin,
  IconXmark,
} from "../../../assets/icon";
import { useMemo } from "react";
import { setOpenPUDelete } from "../../../services/slice/PopUpSlice";
import TranslateText from "../TranslateText";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import NoSearchResults from "../NoSearchResults";
import {
  getLogTemplateMessage,
  getTemplatesMessageAll,
  setOpenDetailTemplatesMessage,
  setOpenEditTemplatesMessage,
  setOpenModalGetLogTemplatesMessage,
  setOpenModalPostTemplatesMessage,
  setPage,
  setSearchText,
} from "../../../services/slice/TemplatesMessage";
import InputSearchBox from "../Input/InputSearchBox";
import BaseButton from "../Button/BaseButton";
import { formatDate } from "../../../utils/functionCommon";

const TableTemplatesMessage = () => {
  const { t } = useTranslation();
  const templateData = useSelector(templatesMessageSelector);
  const { config, isLoading, dataTemplateMessage } = templateData;
  const { option } = config;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getTemplatesMessageAll({ keySearch: config.search }));
  }, [dispatch, config]);

  const { filteredData, dataSource } = useMemo(() => {
    if (!dataTemplateMessage) return { filteredData: [], dataSource: [] };
    const filteredData = dataTemplateMessage.filter((item) =>
      item.title?.toLowerCase().includes(config.search.trim().toLowerCase())
    );
    const dataSource = filteredData.map((item, index) => ({
      ...item,
      key: item.id,
      STT:
        filteredData.length > 10 && option.offset >= 2
          ? (option.offset - 1) * 10 + index + 1
          : index + 1,
      createdAt: formatDate(item.createAt),
    }));

    return { filteredData, dataSource };
  }, [dataTemplateMessage, config.search, option.offset, t]);

  const total = filteredData.length;

  const columns = [
    {
      title: "STT",
      dataIndex: "STT",
      key: "STT",
      className: "centerCell",
      width: 60,
    },
    {
      title: <TranslateText text="Tiêu đề" />,
      dataIndex: "title",
      key: "title",
      className: "title pointer",
      ellipsis: {
        showTitle: false,
      },
      render: (value) => (
        <Tooltip placement="topLeft" title={value}>
          {value}
        </Tooltip>
      ),
    },
    {
      title: <TranslateText text="Người tạo" />,
      key: "createdBy",
      dataIndex: "createdBy",
      className: "centerCell",
    },
    {
      title: <TranslateText text="Thời gian tạo" />,
      dataIndex: "createdAt",
      key: "createdAt",
      className: "centerCell",
    },
    {
      title: <TranslateText text="Chức năng" />,
      key: "action",
      dataIndex: "action",
      className: "evenSpace",
      render: (text, record) => {
        return (
          <div className="evenSpace" style={{ minWidth: "120px" }}>
            <span
              className="pointer iconTbl"
              onClick={() => {
                dispatch(getLogTemplateMessage(record.id));
                dispatch(setOpenModalGetLogTemplatesMessage(true));
              }}
            >
              <Tooltip title="Xem log">
                <IconLock />
              </Tooltip>
            </span>

            <span
              className="pointer iconTbl"
              onClick={() =>
                dispatch(
                  setOpenDetailTemplatesMessage({
                    isOpen: true,
                    id: record.id,
                  })
                )
              }
            >
              <Tooltip title="Xem chi tiết">
                <IconDetail />
              </Tooltip>
            </span>

            <span
              className="pointer iconTbl"
              onClick={() =>
                dispatch(
                  setOpenEditTemplatesMessage({ isOpen: true, id: record.id })
                )
              }
            >
              <Tooltip title="Chỉnh sửa">
                <IconEdit />
              </Tooltip>
            </span>

            <span
              className="pointer iconTbl"
              onClick={() =>
                dispatch(
                  setOpenPUDelete({
                    stateOpen: true,
                    content: record.title,
                    id: record.id,
                  })
                )
              }
            >
              <Tooltip title="Xóa">
                <IconXmark />
              </Tooltip>
            </span>
          </div>
        );
      },
    },
  ];

  const tableLoading = {
    spinning: isLoading, // isLoading là biến boolean để xác định xem có đang loading hay không
    indicator: <IconSpin className="iconSpin" />,
  };
  const rowClassName = (record) => {
    return record.statusPin ? "marked-row" : "";
  };
  return (
    <div>
      <Row style={{ width: "100%" }} justify={"space-between"}>
        <Col className="mr-5">
          <InputSearchBox
            width={435}
            setText={(value) => {
              dispatch(setSearchText(value));
            }}
            placeholder="Tìm kiếm theo tiêu đề"
            key={"searchDeal"}
          />
        </Col>
        <Col style={{ flexGrow: 1, display: "flex", justifyContent: "end" }}>
          <BaseButton
            handleClick={() => dispatch(setOpenModalPostTemplatesMessage(true))}
            icon={
              <IconPlus
                width={16}
                height={14}
                style={{ marginRight: "0.5rem" }}
              />
            }
            content={`Thêm mới`}
            width={120}
            typeBtn="btnOrange"
          />
        </Col>
      </Row>

      {config.search && !dataTemplateMessage ? (
        <Row style={{ width: "100%" }}>
          {" "}
          <NoSearchResults />
        </Row>
      ) : (
        <Row style={{ width: "100%" }}>
          <Table
            loading={tableLoading}
            className="wrapperTblNewsPost"
            style={{ width: "100%", marginTop: "2.6rem" }}
            columns={columns}
            rowClassName={rowClassName}
            dataSource={dataSource}
            pagination={
              total > 10
                ? {
                    onChange: (value) => dispatch(setPage(value)),
                    total,
                    pageSize: 10,
                    current: option.offset,
                    prevIcon: <IconPre />,
                    nextIcon: <IconNext />,
                    showSizeChanger: false,
                  }
                : false
            }
          />
        </Row>
      )}
    </div>
  );
};

export default TableTemplatesMessage;
